import React, { Component, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../css/style.css";
import "../css/purpleresponsive.css";
import renderHTML from "react-render-html";
import $ from "jquery";
import { apiCalling, awsAPIUrlcommon } from "../apiService";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SlotList from "../home/slotList";
import { Helmet } from "react-helmet";

const inperson =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/inperson.png";
const chatg =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/chatg.png";
const phoneg =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/phoneg.png";
const videog =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/videog.png";
const info =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/infosquare.png";
const speciality =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/stethoscope.png";
const service =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/checklist1.png";
const hospital =
  "https://s3.ap-south-1.amazonaws.com/wl.purplehealth.com/image/theme/hospitals.png";

export default class DoctorDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      professionalStatement: "",
      doctorBD: [],
      drSpecialization: [],
      hospitalDetails: [],
      drServices: [],
      appointmentSlotDay: [],
      hospitalImages: [],
      serviceOffered: [],
      Specialities: [],
      officeDetails: [],
      testing: "yyy",
      calFlag: "",
      seoTitle: "",
      description: "",
      // NEW: State for dynamic imports and loading
      homeName: window.sessionStorage.getItem("homeName"),
      isLoading: true, // Start with a loading state
    };
    // NEW: Flag to track if the component is mounted
    this.isMounted_ = false;
  }

  isLoginCheck() {
    // NEW: Use state to check homeName
    if (this.state.homeName === "IMAHospitals") {
      return true;
    } else {
      let flag = true;
      if (!window.sessionStorage.getItem("isLogin")) {
        $("#ForgotPasswordWrap").hide();
        $("#SignupWrap").hide();
        $("#signInWrapDiv").hide();
        flag = false;
      }
      return flag;
    }
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
    $(".react-datepicker__time-container").show();
    $(".react-datepicker__navigation").hide();
    $(".timeClose").show();
  };

  addToFavourites(e) {
    if (this.isLoginCheck() === true) {
      if (e.target.checked) {
        const jsonData = {
          method: "POST",
          body: JSON.stringify({
            functionName: "addToFavourites",
            siteId: window.sessionStorage.getItem("siteId"),
            userId: window.sessionStorage.getItem("userId"),
            favouriteUserId: this.state.doctorBD.userId,
          }),
        };
        apiCalling(jsonData).then((data) => {
          // NEW: Check if component is mounted
          if (!this.isMounted_) return;
          if (data.success === "1") {
            alert(data.successMessage);
          }
        });
        $("#fav").attr("disabled", true);
      }
    }
  }

  DrDetailLiked() {
    $("#dr-detail-liked .imgdislike").toggle();
    $("#dr-detail-liked .imgliked").toggle();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.url !== this.props.match.url) window.location.reload();
  }

  callSiteRequest() {
    let siteurl = "";
    window.sessionStorage.setItem("pathname", window.location.pathname);
    if (!this.state.siteId) {
      siteurl = this.state.siteUrl;
    } else {
      window.sessionStorage.setItem("siteId", this.state.siteId);
    }
    const siteCallRequest = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getSiteDetails",
        siteId: this.state.siteId,
        siteUrl: window.location.host,
      }),
    };
    apiCalling(siteCallRequest).then((data) => {
      // NEW: Check if component is mounted
      if (!this.isMounted_) return;
      if (data.success === "1") {
        var folder = data.siteDetailsData[0].siteData[0].themeName;
        let is_theme_based = data.siteDetailsData[0].siteData[0].is_theme_based;
        let project_folder = data.siteDetailsData[0].siteData[0]?.project_folder
          ? data.siteDetailsData[0].siteData[0]?.project_folder
          : "DoctorsCabin";
        if (data.siteDetailsData[0].siteData[0].id) {
        } else {
          folder = "DoctorsCabin";
        }
        window.sessionStorage.setItem("homeName", folder);
        // NEW: Update state and set loading to false
        this.setState({
          homeName: folder,
          isLoading: false,
        });
        if (is_theme_based === false && project_folder !== "") {
          folder = project_folder;
        } else {
          folder = data.siteDetailsData[0].siteData[0].themeName;
        }
        if (data.siteDetailsData[0].siteData[0].id) {
        } else {
          folder = "DoctorsCabin";
        }
        //folder = 'SAANVI'
        window.sessionStorage.setItem(
          "siteId",
          data.siteDetailsData[0].siteData[0].id
        );
        window.sessionStorage.setItem(
          "themeId",
          data.siteDetailsData[0].siteData[0].themeId
        );
        window.sessionStorage.setItem(
          "themeName",
          data.siteDetailsData[0].siteData[0].themeName
        );
        window.sessionStorage.setItem("themeVersion", "0");
        window.sessionStorage.setItem("homeName", folder);
        //  window.sessionStorage.setItem("homeName", "ida");
        window.sessionStorage.setItem("reload", "1");
        window.sessionStorage.setItem(
          "dashboard_html",
          data.siteDetailsData[0].siteData[0].dashboard_html
        );
        window.sessionStorage.setItem(
          "theme_custom_color",
          data.siteDetailsData[0].siteData[0].theme_custom_color
        );
        window.sessionStorage.setItem(
          "contact_emailId",
          data.siteDetailsData[0].siteData[0].emailId
        );
        window.sessionStorage.setItem(
          "contact_no",
          data.siteDetailsData[0].siteData[0].contact_no
        );
        window.sessionStorage.setItem(
          "fav_icon",
          data.siteDetailsData[0].siteData[0].fav_icon
        );
        window.sessionStorage.setItem(
          "seo_description",
          data.siteDetailsData[0].siteData[0].seo_description
        );
        window.sessionStorage.setItem(
          "seo_keywords",
          data.siteDetailsData[0].siteData[0].seo_keywords
        );
        window.sessionStorage.setItem(
          "seo_title",
          data.siteDetailsData[0].siteData[0].seo_title
        );
        window.sessionStorage.setItem(
          "slug",
          data.siteDetailsData[0].siteData[0].slug
        );
        window.sessionStorage.setItem(
          "isIDALogin",
          data.siteDetailsData[0].siteData[0].isIDALogin
        );
        //window.sessionStorage.setItem("google_analytics_script",data.siteDetailsData[0].siteData[0].google_analytics_script);
        var google_analytics_script =
          data.siteDetailsData[0].siteData[0].google_analytics_script;

        var clarityId = "";
        var googleId = "";
        if (google_analytics_script.length < 30) {
          var Gdata = google_analytics_script.split(",");
          if (Gdata[0]) {
            googleId = Gdata[0];
          }
          if (Gdata[1]) {
            clarityId = Gdata[1];
          }
        }

        window.sessionStorage.setItem("clarityId", clarityId);
        window.sessionStorage.setItem("googleId", googleId);
        window.sessionStorage.setItem(
          "siteName",
          data.siteDetailsData[0].siteData[0].siteName
        );
        window.sessionStorage.setItem(
          "book_appointment_terms",
          data.siteDetailsData[0].siteData[0].book_appointment_terms
        );
        window.sessionStorage.setItem(
          "video_chat_terms",
          data.siteDetailsData[0].siteData[0].video_chat_terms
        );
        window.sessionStorage.setItem(
          "hospital_working_time",
          data.siteDetailsData[0].siteData[0].hospital_working_time
        );
        window.sessionStorage.setItem(
          "site_url",
          data.siteDetailsData[0].siteData[0].site_url
        );
        window.sessionStorage.setItem(
          "title",
          data.siteDetailsData[0].siteData[0].title
        );
        window.sessionStorage.setItem(
          "fbPixel",
          data.siteDetailsData[0].siteData[0].fbPixel
        );
        window.sessionStorage.setItem(
          "advertisementScript",
          data.siteDetailsData[0].siteData[0].advertisementScript
        );

        window.sessionStorage.setItem(
          "termsAndCondition",
          data.siteDetailsData[0].siteData[0].termsAndCondition
        );
        window.sessionStorage.setItem(
          "privacyPolicy",
          data.siteDetailsData[0].siteData[0].privacyPolicy
        );

        window.sessionStorage.setItem(
          "hasHealthTracker",
          data.siteDetailsData[0].siteData[0].hasHealthTracker
        );
        window.sessionStorage.setItem(
          "siteLogo",
          data.siteDetailsData[0].siteData[0].logo_path
        );
        window.sessionStorage.setItem(
          "groupHospitalAdminId",
          data.siteDetailsData[0].groupHospitalAdminData[0]
            ?.groupHospitalAdminId
        );
        window.sessionStorage.setItem(
          "headerData",
          JSON.stringify(data.siteDetailsData[0].headerData)
        );

        window.sessionStorage.setItem(
          "footerData",
          JSON.stringify(data.siteDetailsData[0].footerData)
        );

        const hosDataVar = JSON.stringify(data.siteDetailsData[0].hospitalData);
        window.sessionStorage.setItem(
          "siteServices",
          JSON.stringify(data.siteDetailsData[0].services)
        );
        if (hosDataVar) {
          window.sessionStorage.setItem(
            "footerhospitalData",
            JSON.stringify(data.siteDetailsData[0].hospitalData)
          );

          window.sessionStorage.setItem(
            "footerHospitalName",
            data.siteDetailsData[0].hospitalData.hospitalName
          );
          window.sessionStorage.setItem(
            "footerHospitalcity",
            data.siteDetailsData[0].hospitalData.city
          );
          window.sessionStorage.setItem(
            "footerHospitaladdress",
            data.siteDetailsData[0].hospitalData.address
          );
          window.sessionStorage.setItem(
            "footerHospitalstateName",
            data.siteDetailsData[0].hospitalData.stateName
          );
          window.sessionStorage.setItem(
            "footerHospitalzipCode",
            data.siteDetailsData[0].hospitalData.zipCode
          );
        }
        if (data.siteDetailsData[0].themeSectionList) {
          for (
            let i = 0;
            i < data.siteDetailsData[0].themeSectionList.length;
            i++
          ) {
            window.sessionStorage.setItem(
              data.siteDetailsData[0].themeSectionList[i].themeSectionName,
              JSON.stringify(
                data.siteDetailsData[0].themeSectionList[i].themeSectionContent
              )
            );
          }
        }
        window.sessionStorage.setItem(
          "doctorDetails",
          JSON.stringify(data.siteDetailsData[0].doctorDetails)
        );

        // window.location.href = "/doctor/videoSchedule";

        // this.callLoginFunction();
        // alert("root")
        //window.location.href="/maintenance"
      }
    });
  }

  componentDidMount() {
    // NEW: Set the mounted flag
    this.isMounted_ = true;

    let slug = this.props.match.params.slug;
    slug = slug.split("-");
    let doctorId = slug[0];

    // NEW: Check state for homeName, not a top-level variable
    if (!this.state.homeName) {
      window.sessionStorage.setItem("pathname", window.location.pathname);
      this.callSiteRequest();
    } else {
      // If homeName is already in sessionStorage, we can stop loading
      this.setState({ isLoading: false });
    }

    $(".loader").show();
    $(".generalFlag").hide();
    let self = this;
    window.sessionStorage.setItem("AppFlag", "NA");

    $("#callLink").hide();
    $("#chatLink").hide();
    $("#videoLink").hide();
    $("#emailLink").hide();
    $("#bookLink").hide();

    if (doctorId) {
      window.sessionStorage.setItem("doctorPID", doctorId);
    } else {
      doctorId = window.sessionStorage.getItem("doctorPID");
    }

    const doctorDetails = {
      method: "POST",
      body: JSON.stringify({
        functionName: "doctorProfile",
        siteId: window.sessionStorage.getItem("siteId"),
        doctorId: doctorId,
      }),
    };
    apiCalling(doctorDetails).then((data) => {
      // NEW: Check if component is mounted
      if (!this.isMounted_) return;
      if (data.success === "1") {
        $(".loader").hide();

        this.setState({
          doctorBD: data.doctorData[0],
          seoTitle: data.doctorData[0].seoTitle,
          description: data.doctorData[0].description,
        });
        window.sessionStorage.setItem(
          "doctorName",
          data.doctorData[0].doctorName
        );
        this.setState({
          officeDetails: data.doctorData[0].officeDetails,
        });
        this.setState({
          serviceOffered: data.doctorData[0].serviceOffered,
        });
        this.setState({
          Specialities: data.doctorData[0].specialization,
        });
        this.setState({
          hospitalDetails: data.doctorData[0].hospitalDetails,
        });
        window.sessionStorage.setItem(
          "hospitalName",
          data.doctorData[0].hospitalDetails[0].name
        );
        this.setState({
          hospitalImages: data.doctorData[0].galleryImages,
        });

        data.doctorData[0].specialization.map((sp) => {
          this.setState({
            drSpecialization: this.state.drSpecialization.concat(
              sp.specialization
            ),
          });
        });

        data.doctorData[0].services.map((sp) => {
          if (sp === "Call a Doctor") {
            $("#callLink").show();
          }
          if (sp === "Messaging") {
            $("#chatLink").show();
          }
          if (sp === "Video Chat") {
            $("#videoLink").show();
          }
          if (sp === "Email Consult") {
            $("#emailLink").show();
          }
          if (sp === "Book Appointment") {
            $("#bookLink").show();
          }
        });

        if (data.doctorData[0].Favouriteflag === "1") {
          $("#dr-detail-liked .imgdislike").toggle();
          $("#dr-detail-liked .imgliked").toggle();
        }
      } else {
        alert(data.errorMessage);
      }
    });

    if (this.props.location.doctorList) {
      for (let i = 0; i < this.props.location.doctorList.length; i++) {
        if (
          this.props.location.doctorList[i].doctorId.toString() === doctorId
        ) {
          $("#fav").attr("checked", true);
          break;
        }
      }
    }
  }

  componentWillUnmount() {
    // NEW: Clear the mounted flag
    this.isMounted_ = false;
  }

  showService() {
    this.state.hospitalDetails.map((hos) => {
      // alert(hos.phoneNumber);
    });
  }

  isLoginValidate(doctorId, hospitalId, flagOption, bySlot, selDate, selTime) {
    if (this.isLoginCheck() === true) {
      if (doctorId) {
        window.sessionStorage.setItem("loginValidate", "");
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("flagOption", flagOption);
        window.sessionStorage.setItem("bySlot", bySlot);
        window.sessionStorage.setItem("selDate", selDate);
        window.sessionStorage.setItem("selTime", selTime);
        window.sessionStorage.setItem("doctor_details", "1");
        window.location.href = "/patient/bookappointment";
      } else if (window.sessionStorage.getItem("appDocId")) {
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("flagOption", flagOption);
        window.location.href = "/patient/bookappointment";
      } else {
      }
    } else {
      window.sessionStorage.setItem("loginValidate", "book");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", flagOption);
      window.sessionStorage.setItem("bySlot", bySlot);
      window.sessionStorage.setItem("selDate", selDate);
      window.sessionStorage.setItem("selTime", selTime);
      window.sessionStorage.setItem("doctor_details", "1");
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }

  changeHospital() {
    let hosid = $("#hospitalDrop").val();
    $(".bookLink").hide();
    $(".videoLink").hide();
    $(".callLink").hide();
    $(".callLinkChat").hide();

    $("#bookLink" + hosid).show();
    $("#videoLink" + hosid).show();
    $("#callLink" + hosid).show();
    $("#callLinkChat" + hosid).show();
  }

  chatmessageClickValidate(
    doctorId,
    hospitalId,
    chatDoctorPanelId,
    textChatPrice
  ) {
    $(".loader").show();
    const jsonData = {
      method: "POST",
      body: JSON.stringify({
        functionName: "messageChatFree",
        chatDoctorPanelId: chatDoctorPanelId,
        memberId: window.sessionStorage.getItem("userId"),
        doctorId: doctorId,
        hospitalId: hospitalId,
      }),
    };
    apiCalling(jsonData).then((data) => {
      // NEW: Check if component is mounted
      if (!this.isMounted_) return;
      if (data.success === "1") {
        $(".loader").show();
        window.sessionStorage.setItem("API_KEY", data.API_KEY);
        window.sessionStorage.setItem("sessionId", data.sessionId);
        window.sessionStorage.setItem("token", data.token);
        window.sessionStorage.setItem("appDocId", doctorId);
        window.sessionStorage.setItem("appHosId", hospitalId);
        window.sessionStorage.setItem("chatDoctorPanelId", data.chatGroupId);
        window.location.href = "/chat/chatmessage";
      } else {
        alert(data.errorMessage);
      }
    });
  }

  chatmessageClick(doctorId, hospitalId, chatDoctorPanelId, textChatPrice) {
    if (this.isLoginCheck() === true) {
      this.chatmessageClickValidate(
        doctorId,
        hospitalId,
        chatDoctorPanelId,
        textChatPrice
      );
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatFree");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatDoctorPanelId);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }

  isLoginValidateTextChatWithPayment(
    doctorId,
    hospitalId,
    chatdoctorpanelid,
    messaging_cost
  ) {
    if (this.isLoginCheck() === true) {
      window.sessionStorage.setItem("loginValidate", "");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      window.location.href = "/patient/textchatpayment";
    } else {
      window.sessionStorage.setItem("loginValidate", "TextChatPay");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("chatDoctorPanelId", chatdoctorpanelid);
      window.sessionStorage.setItem("messaging_cost", messaging_cost);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }

  render() {
    // NEW: Handle loading state
    if (this.state.isLoading) {
      return <div>Loading...</div>;
    }

    // NEW: Dynamically define Header and Footer once homeName is available
    const DynamicHeader = React.lazy(() => import(`../${this.state.homeName}/header`));
    const DynamicFooter = React.lazy(() => import(`../${this.state.homeName}/footer`));

    var dateSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            swipeToSlide: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            swipeToSlide: true,
          },
        },
      ],
    };

    return (
      <div className="purpleWrap">
        <Suspense fallback={<div></div>}>
          <section>
            <DynamicHeader />
          </section>
        </Suspense>
        <Helmet>
          <title>{this.state.seoTitle}</title>
          <meta name="description" content={this.state.description} />
        </Helmet>
        <div className="container">
          <div className="doctorDetailMain">
            <div className="doctorDetailProfile mt-5">
              <div className="doctorDetailLeft">
                {this.isLoginCheck() === true ? (
                  <label className="drListHearts imgshowhide">
                    <input
                      id="fav"
                      type="checkbox"
                      onChange={(e) => this.addToFavourites(e)}
                    />
                    <span class="checkmark"></span>
                  </label>
                ) : (
                  ""
                )}

                <div className="doctorDetailProfileImg">
                  <img
                    src={this.state.doctorBD.image}
                    width="110"
                    height="110"
                    alt=""
                  ></img>
                </div>
                <h5 class="drName">
                  {this.state.doctorBD.doctorName}
                  {"   "}
                  {this.state.doctorBD.doctorEducation}
                </h5>
                <span class="drspecialist">
                  {this.state.doctorBD.primarySpeciality}
                </span>
                <p class="drspecialist-text mt-2 mb-0"> </p>
                {this.state.hospitalDetails.length !== 1 && (
                  <p className="mb-0">
                    <select
                      class="drspecialist-hospital"
                      onClick={(e) => this.changeHospital()}
                      id="hospitalDrop"
                    >
                      {this.state.hospitalDetails.map((hospial) => {
                        return (
                          <option key={hospial.hospitalId} value={hospial.hospitalId}>
                            {hospial.name}
                          </option>
                        );
                      })}
                    </select>
                  </p>
                )}
              </div>
              <div
                className="drServiceMain"
                id={"drServiceMain" + this.props.consti}
              >
                <div className="drService-subhead">SERVICES:</div>

                {this.state.hospitalDetails.map((hos, index) => {
                  let services = hos.hospitalServices;
                  let bookShow = "none";
                  let vcShow = "none";
                  let auShow = "none";
                  let chat = "none";
                  let show = index === 0 ? "block" : "none";
                  services.map((it) => {
                    if (
                      it.serviceName === "Book Appointment" &&
                      it.status === 1
                    ) {
                      bookShow = "Book Appointment";
                    }
                    if (it.serviceName === "Video Chat" && it.status === 1) {
                      vcShow = "Video Chat";
                    }
                    if (it.serviceName === "Call a Doctor" && it.status === 1) {
                      auShow = "Call a Doctor";
                    }
                    if (it.serviceName === "Messaging" && it.status === 1) {
                      chat = "Messaging";
                    }
                  });
                  return (
                    <div key={hos.hospitalId}>
                      {bookShow === "Book Appointment" && (
                        <div
                          className="drServiceSp drServiceSp-book generalFlag bookLink"
                          id={"bookLink" + hos.hospitalId}
                          style={{ display: show }}
                        >
                          <span
                            className="text-decoration-none drServiceSpSpan"
                            onClick={(e) => {
                              this.isLoginValidate(
                                this.props.location.doctorId,
                                hos.hospitalId,
                                "p",
                                "No",
                                "",
                                ""
                              );
                            }}
                          >
                            <img src={inperson} alt=""></img> In-Person
                            <span className="drService-rate">
                              {hos.priceDetails[0].inPersonprice !== "0.00" &&
                                "₹" + hos.priceDetails[0].inPersonprice}
                            </span>
                          </span>
                        </div>
                      )}
                      {vcShow === "Video Chat" && (
                        <div
                          className="drServiceSp drServiceSp-videochat generalFlag videoLink"
                          id={"videoLink" + hos.hospitalId}
                          style={{ display: show }}
                        >
                          <span
                            className="text-decoration-none drServiceSpSpan"
                            onClick={(e) => {
                              this.isLoginValidate(
                                this.props.location.doctorId,
                                hos.hospitalId,
                                "v",
                                "No",
                                "",
                                ""
                              );
                            }}
                          >
                            <img src={videog} alt=""></img> Video Chat
                            <span className="drService-rate">
                              ₹ {hos.priceDetails[0].videoChatPrice}
                            </span>
                          </span>
                        </div>
                      )}
                      {auShow === "Call a Doctor" && (
                        <div
                          className="drServiceSp drServiceSp-call generalFlag callLink"
                          id={"callLink" + hos.hospitalId}
                          style={{ display: show }}
                        >
                          <span
                            className="text-decoration-none drServiceSpSpan"
                            onClick={(e) => {
                              this.isLoginValidate(
                                this.props.location.doctorId,
                                hos.hospitalId,
                                "c",
                                "No",
                                "",
                                ""
                              );
                            }}
                          >
                            <img src={phoneg} alt=""></img> Audio Chat
                            <span className="drService-rate">
                              ₹ {hos.priceDetails[0].audioPrice}
                            </span>
                          </span>
                        </div>
                      )}
                      {chat === "Messaging" && (
                        <div
                          className="drServiceSp drServiceSp-chat callLinkChat"
                          id={"callLinkChat" + hos.hospitalId}
                          style={{ display: show }}
                        >
                          {hos.priceDetails[0].textChatPrice !== "0.00" ? (
                            <span
                              onClick={(e) => {
                                this.isLoginValidateTextChatWithPayment(
                                  this.props.location.doctorId,
                                  hos.hospitalId,
                                  hos.chatDoctorPanelId,
                                  hos.priceDetails[0].textChatPrice
                                );
                              }}
                              className="text-decoration-none drServiceSpSpan"
                            >
                              <img src={chatg} alt=""></img> Text Chat
                              <span className="drService-rate">
                                ₹{hos.priceDetails[0].textChatPrice}
                              </span>
                              <span className="expireDay">
                                {this.state.doctorBD.daysOfExpiry &&
                                  "Days of Expiry :" +
                                  this.state.doctorBD.daysOfExpiry}
                              </span>
                            </span>
                          ) : (
                            <span
                              onClick={() =>
                                this.chatmessageClick(
                                  this.props.location.doctorId,
                                  hos.hospitalId,
                                  hos.chatDoctorPanelId,
                                  hos.priceDetails[0].textChatPrice
                                )
                              }
                              className="text-decoration-none drServiceSpSpan"
                            >
                              <img src={chatg} alt=""></img> Text Chat
                              <span className="drService-rate">
                                {" "}
                                ₹{hos.priceDetails[0].textChatPrice}
                              </span>
                              <span className="expireDay">
                                {this.state.doctorBD.daysofexpiry &&
                                  "Days of Expiry : " +
                                  this.state.doctorBD.daysofexpiry}
                              </span>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="doctorDetailStatement mt-lg-5 mt-md-5 mt-sm-2">
              <h4 style={{ position: "relative" }}>
                Professional Statement
                <div class="iconUl icon-head-text">
                  <div id="iconOuterSocial"></div>
                </div>
              </h4>
              <p>{this.state.doctorBD.professionalStatement}</p>
            </div>
          </div>
          <div className="drDetailServicemain text-left">
            <span className="drDetailServiceSpan drDetailServiceSpan-active drDetSpanUnderline">
              <img src={info} class="" width="20"></img>
              <span className="">doctor info</span>
            </span>
          </div>
          {this.state.hospitalDetails.map((hdata) => {
            let place = [
              hdata.city.replaceAll(",", ", "),
              hdata.state.replaceAll(",", ", "),
              hdata.country.replaceAll(",", ", "),
            ];
            var i = 0;
            return (
              <div key={hdata.hospitalId} class="drDetailHospital row drDetailHospitalPadding mx-0">
                <div class="col-lg-6 drDetHosptl">
                  <div class="col-lg-5 drDetailHospitalImg">
                    <img src={hdata.hospitalImage}></img>
                  </div>

                  <div class="col-lg-7 drDetailHospitalDet drDetailHospitalContent">
                    <h5 class="drDetailHospitalHead drDetailHospitalTitle">
                      {hdata.name}
                    </h5>
                    <p>
                      {hdata.address
                        .replaceAll(",", ", ")
                        .replaceAll("  ", " ")}
                    </p>
                    <p>{place.join(", ")}</p>

                    <p>{hdata.zip === "" ? "" : "ZIP - " + hdata.zip}</p>
                    <p>Phone - {hdata.phoneNumber}</p>
                  </div>
                </div>
                <div class="col-lg-6 calendarDiv">
                  <SlotList
                    hospialId={hdata.hospitalId}
                    doctorId={window.sessionStorage.getItem("doctorPID")}
                  ></SlotList>
                </div>
              </div>
            );
          })}

          <div
            className="drDetailServicemainTab my-4"
            style={{ float: "none" }}
          >
            <Tabs>
              <TabList>
                <Tab>
                  <img
                    src={speciality}
                    class="imgshow-act mr-2"
                    width="20"
                  ></img>
                  <span className="drDetSpanUnderline">specialities</span>
                </Tab>
                <Tab>
                  <img src={service} class="imgshow-act mr-2" width="20"></img>
                  <span className="drDetSpanUnderline">service offered</span>
                </Tab>
                <Tab>
                  <img src={hospital} class="imgshow-act mr-2" width="20"></img>
                  <span className="drDetSpanUnderline">office details</span>
                </Tab>
              </TabList>

              <TabPanel>
                <div class="form-head"> </div>
                {this.state.Specialities.map((s) => {
                  return (
                    <ul key={s.specialization}>
                      <li>{s.specialization ? s.specialization : ""}</li>
                    </ul>
                  );
                })}
                {this.state.Specialities.length === 0 && "No Data Available"}
              </TabPanel>
              <TabPanel>
                <div class="form-head"> </div>
                {this.state.serviceOffered.map((s, index) => {
                  return <div key={index}>{renderHTML(s.serviceOffered)}</div>;
                })}
                {this.state.serviceOffered.length === 0 && "No Data Available"}
              </TabPanel>
              <TabPanel>
                <div class="form-head"> </div>
                {this.state.officeDetails.map((s, index) => {
                  return <div key={index}>{renderHTML(s.officeDetails)}</div>;
                })}
                {this.state.officeDetails.length === 0 && "No Data Available"}
              </TabPanel>
            </Tabs>
          </div>
        </div>
        <Suspense fallback={<div></div>}>
          <section>
            <DynamicFooter />
          </section>
        </Suspense>
      </div>
    );
  }
}